import { Capacitor } from "@capacitor/core";

const ENABLED_KEY = "rc_biometric_enabled";

// Biometric unlock is only meaningful inside the native app.
export const biometricSupported = () => Capacitor.isNativePlatform();

export async function biometricAvailable() {
  if (!Capacitor.isNativePlatform()) return false;
  try {
    const { BiometricAuth } = await import("@aparajita/capacitor-biometric-auth");
    const info = await BiometricAuth.checkBiometry();
    return !!info.isAvailable;
  } catch {
    return false;
  }
}

// Prompts Face ID / Touch ID / fingerprint. Throws (BiometryError) on failure or cancel.
export async function biometricVerify(reason = "Unlock Hutanohwevanhu.org") {
  const { BiometricAuth } = await import("@aparajita/capacitor-biometric-auth");
  await BiometricAuth.authenticate({
    reason,
    cancelTitle: "Cancel",
    allowDeviceCredential: true,
    iosFallbackTitle: "Use passcode",
    androidTitle: "Unlock Hutanohwevanhu.org",
    androidSubtitle: "Verify your identity",
    androidConfirmationRequired: false,
  });
  return true;
}

export const isBiometricEnabled = () => {
  try { return localStorage.getItem(ENABLED_KEY) === "1"; } catch { return false; }
};
export const setBiometricEnabled = (on) => {
  try { on ? localStorage.setItem(ENABLED_KEY, "1") : localStorage.removeItem(ENABLED_KEY); } catch (e) { console.debug("setBiometricEnabled: storage unavailable", e); }
};
